export const ADD_FOOD_TAXES = "ADD_FOOD_TAXES"
export const UPDATE_FOOD_TAXES = "UPDATE_FOOD_TAXES"
export const DELETE_FOOD_TAXES = "DELETE_FOOD_TAXES"
export const CLEAR_FOOD_TAXES = "CLEAR_FOOD_TAXES"